import type React from 'react';
import { cn } from '@/lib/utils';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'success' | 'warning';
}

const variantClasses: Record<string, string> = {
  default:
    'bg-utility-brand-50 text-utility-brand-700 ring-1 ring-utility-brand-200 ring-inset dark:bg-utility-brand-50 dark:text-utility-brand-700 dark:ring-utility-brand-200',
  destructive:
    'bg-utility-error-50 text-utility-error-700 ring-1 ring-utility-error-200 ring-inset',
  secondary:
    'bg-utility-gray-50 text-utility-gray-700 ring-1 ring-utility-gray-200 ring-inset',
  outline:
    'bg-transparent text-text-secondary ring-1 ring-border-primary ring-inset',
  success:
    'bg-utility-success-50 text-utility-success-700 ring-1 ring-utility-success-200 ring-inset',
  warning:
    'bg-utility-warning-50 text-utility-warning-700 ring-1 ring-utility-warning-200 ring-inset',
};

export const Badge = ({ variant = 'default', className, children, ...props }: Props) => {
  return (
    <div
      className={cn(
        'inline-flex items-center justify-center rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap select-none',
        variantClasses[variant],
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};
